import React, { Component } from 'react';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';
import UnAuthorised from './UnAuthorised';
import { Alert, DateRangePicker } from 'rsuite';
import 'react-select2-wrapper/css/select2.css';
import Select2 from 'react-select2-wrapper';
import {
  URL_BASICFORGERY,
  createAndDownloadPdfForRcPrime,
  API_DOC_BASE_URL,
  rc_prime_pdf_Authorization_Token,
  rc_prime_pdf_user_id,
  rc_prime_pdf_rto_user_id,
  unlink_file,
  LOGIN_TYPE_ADMIN,
  LOGIN_TYPE_USER,
  CLIENT_EDIT_VIEW,
  SERVICE23_TEXT,
  SERVICE31_TEXT
} from './helper/Constants';

import Apihelpers from './helper/ApiHelper';
import FileDownload from 'js-file-download';
import { reactLocalStorage } from 'reactjs-localstorage';
import Header from './include/Header';

class basicForgeryPdf extends Component {
  state = {
    Pan_Number: '',
    docType:'',
    docFiles: [],
    docFilesB: [],
    matchFields:[],
    basic_forgery_details: [],
    MsgBoxText: '',
    is_data_found: false,
    data_not_found: '',
    bbuser_have_plan: false,
    rc_prime_pdf_user_id: '',
    rc_prime_pdf_Authorization_Token: '',
    rc_prime_pdf_rto_user_id: '',
    urlForBackButton: '',
    textMachedByDefault:[{id:'name',text:'By Name'},{id:'father',text:'By Father Name'},{id:'businessPan',text:'By Card Number'}],
    textMachedByField:[],
  };
  constructor(props) {
    super(props);
  }
  async componentDidMount() {
    if (reactLocalStorage.get('login_type') === LOGIN_TYPE_USER) {
      this.setState({
        urlForBackButton: `${'/admin/client-edit-view/' +
          reactLocalStorage.get('login_user_id')}`,
      });
      this.Find_User_Have_Pan_Fetch_Pdf_Plan();
    }
    //when admin login then for get price prime data using testing Qa data
    if (reactLocalStorage.get('login_type') === LOGIN_TYPE_ADMIN) {
      const adminToken = 'Bearer '+ reactLocalStorage.get("internalToken");
      this.setState({
        rc_prime_pdf_user_id: rc_prime_pdf_user_id,
        rc_prime_pdf_Authorization_Token: adminToken,//rc_prime_pdf_Authorization_Token,
        rc_prime_pdf_rto_user_id: rc_prime_pdf_rto_user_id,
        urlForBackButton: '/admin/client-list',
      });
    }

  }
  filterFileData = (apidata) => {
    let apidataNew = {};
      Object.keys(apidata).forEach((key) => {
        if (key === 'identityCardDetail') {
          if(Object.keys(apidata[key]).length > 0) {
            apidataNew.identityCardDetail_match = apidata[key].match;
            apidataNew.identityCardDetail_predictedType = apidata[key].predictedType;
          }
        } else if (key === 'textMatchDetail') {
          if(Object.keys(apidata[key]).length > 0) {
            let tmd = '';
            Object.keys(apidata[key]).forEach((keyB)=>{
              tmd +=  [keyB]+':- (Score: '+apidata[key][keyB].score+', Verb: '+apidata[key][keyB].verb+', Best Match: '+apidata[key][keyB].bestMatch+')    ';
            });
            let newkey = 'textMatchDetail_'+[key];
            console.log('newkey',newkey);
            apidataNew[newkey] = tmd;
          }
        } else if (key === 'colorDetail') {
          apidataNew.colorDetail_forgery = apidata[key].forgery;
          apidataNew.colorDetail_message = apidata[key].message;
          let colors = '';
          if (apidata[key].dominantColors.length > 0) {
            apidata[key].dominantColors.map((it,i)=>{
              if(apidata[key].dominantColors.length -1 === i) {
                colors += it;
              } else {
                colors += it+', ';
              }
              
            })
          }
          apidataNew.colorDetail_dominantColors = colors;
        } else {
          apidataNew[key] = apidata[key];
        }
        
      })
    this.setState({
      basic_forgery_details: apidataNew,
      is_data_found: true,
    });
  }
  get_basic_forgery_details = (event) => {
    $('.loader').css('display', 'block');
    if (this.state.docType === '') {
      Alert.error('Please Select Card Type');
      $('.loader').css('display', 'none');
      return;
    }
    if (this.state.docFiles.length === 0) {
      Alert.error('Please Upload Identity Card Images/PDF');
      $('.loader').css('display', 'none');
      return;
    }
    const headerData = {
      authorization_Token: this.state.rc_prime_pdf_Authorization_Token,
    };
    const formData = new FormData();
		formData.append('user_id','5fed7790648ae566a563014c');
		formData.append('identityCardType',this.state.docType);
		//formData.append('documents',$(".doc-files")[0].files[0]);
    for (let i = 0; i < this.state.docFilesB.length; i++) {
      formData.append('documents', this.state.docFilesB[i]);
    }

    let fieldArray = {};
    $(".matchField").each(function(){
      let key = $(this).attr('data-id');
      let val = $(this).find('input').val();
      //console.log('key '+key+' val '+val);
      fieldArray[key] = val;
    });
    console.log("fieldArray--------------",JSON.stringify(fieldArray));
    formData.append('textMatchedField',JSON.stringify(fieldArray));
    //formData.append('authorization_Token',this.state.rc_prime_pdf_Authorization_Token);
    Apihelpers.get_adhaarExtaction_details_apihelper(
      API_DOC_BASE_URL + URL_BASICFORGERY,
      formData,
      headerData
    ).then(res => {
      //console.log('res',res);
      if (res.data.statusCode == 200) {
        let result = res.data.data;
        console.log("result-------",result);
        $('.loader').css('display', 'none');
        this.filterFileData(res.data.data);
      } else {
        $('.loader').css('display', 'none');
        this.setState({
          is_data_found: false,
          data_not_found: 'Data Not Found',
        });
      }
    });


      // const data = {
      //   user_id: this.state.rc_prime_pdf_user_id,
      //   authorization_Token: this.state.rc_prime_pdf_Authorization_Token,
      //   textMatchedField:{"name":"Suchitra"},
      //   identityCardType:"aadhaar", // types: aadhaar | individualPan | businessPan | dl | passport | voterId | unknown
      //   imageUrl: [
      //   "https://careline.girnarcare.com/upload/campaign_data/ubdsqsg1600844692/92787/51/1607597117WhatsAppImage2020-12-10at3.58.44PM.jpeg"
      //    ]
      // };
      // Apihelpers.get_rcprime_details_apihelper(
      //   API_DOC_BASE_URL + URL_BASICFORGERY,
      //   data,
      // ).then(res => {
      //   if (res.data.statusCode == 200) {
      //     let result = res.data.data;
      //     console.log("result-------",result)
      //     $('.loader').css('display', 'none');
      //     this.setState({
      //       basic_forgery_details: res.data.data,
      //       is_data_found: true,
      //     });
      //   } else {
      //     $('.loader').css('display', 'none');
      //     this.setState({
      //       is_data_found: false,
      //       data_not_found: 'Data Not Found',
      //     });
      //   }
      // });

      //alert('submiting....');
      //$('.loader').css('display', 'none');
  };
  createAndDownloadPdf = () => {
    $('.loader').css('display', 'block');
    let currentDateTime = Date.now();
    if (
      this.state.basic_forgery_details &&
      this.state.is_data_found == true
    ) {
      const data = {
        doc_details: [this.state.basic_forgery_details],
        file_name:
          'basic_forgery_details_' +
          this.state.Pan_Number +
          '_' +
          currentDateTime +
          '.pdf',
        type: 'basicForgeryPdf',
      };
      Apihelpers.createAndDownloadPdf(
        createAndDownloadPdfForRcPrime,
        data,
      ).then(res => {
        console.log(res);
        if (res.status == 201) {
          var fileName = data.file_name;
          Apihelpers.downloadFileresponse(
            'export-rcprime-reportpdf/' + fileName,
          )
            .then(res => {
              FileDownload(res.data, fileName);
              const detlete_file_path = {
                filepath: 'rc_prime_pdf_report/' + fileName,
              };
              Apihelpers.postdataresponse(unlink_file, detlete_file_path);
            })
            .catch(err => {
              console.log(err);
            });
            $('.loader').css('display', 'none');
        } else {
          $('.loader').css('display', 'none');
          Alert.error('Error While Generating Report');
        }
      });
      //$('.loader').css('display', 'none');
    } else {
      $('.loader').css('display', 'none');
      Alert.error('Data Not Found');
    }
  };
  On_docs_input_change(e) {
    let namesArray = [];
    for(var i=0; e.target.files.length > i; i++) {
      //console.log('i----------',i);
      namesArray.push(e.target.files[i].name);
    }
    this.setState({
      docFiles: namesArray,
      docFilesB: e.target.files
    });
  }
  async Find_User_Have_Pan_Fetch_Pdf_Plan() {
    const bbuserid = reactLocalStorage.get('login_user_id');
    var startdate = '';
    var enddate = '';
    const ClientDetailsPostData = {
      startdate: '',
      enddate: '',
    };
    Apihelpers.postdataresponse(
      CLIENT_EDIT_VIEW + bbuserid,
      ClientDetailsPostData,
    ).then(async res => {
      if (res.data.status === true) {
        this.setState({
          rc_prime_pdf_Authorization_Token: 'Bearer '+ res.data.data[0].bbuserInfo[0].token,
        });
        /*var bbPaymentHistory = res.data.data[0].bbuserpaymenthistoriesInfo;
        let token = bbPaymentHistory.map(s => {
          if (s.is_active == true) {
            this.setState({
              rc_prime_pdf_Authorization_Token: 'Bearer ' + s.token,
            });
            return s.token;
          }
        });*/
        this.setState({
          rc_prime_pdf_user_id: bbuserid,
          rc_prime_pdf_rto_user_id: res.data.data[0].bbuserInfo[0].userid,
        });
        var parserActivePlan = JSON.parse(
          res.data.data[0].bbuserInfo[0].active_plan,
        );
        if (parserActivePlan.service.length > 0) {
          parserActivePlan.service.map((dataOfelement, index) => {
            if (
              dataOfelement.isActive == 1 &&
              dataOfelement.plantype === SERVICE23_TEXT
            ) {
              this.setState({ bbuser_have_plan: true });
            }
          });
        }
      }
    });
  }
  handleChangeMachedBy(event) {
    let selected=[];
    let selectedOption=(event.target.selectedOptions);
    for (var i = 0; i < selectedOption.length; i++){
      //selected.push({val:selectedOption.item(i).value, label:selectedOption.item(i).text});
      selected.push(selectedOption.item(i).value);
    }
    if(selected.length > 0) {
      this.setState({textMachedByField:selected});
    }
    //console.log('selected',selected);
  }
  getMatchFieldsValues(e,i) {
    let array = [...this.state.matchFields];
    array[i] = e.target.value;
    this.setState({
      matchFields:array
    });
    console.log('array',array);
  }
  render() {
    if (reactLocalStorage.get('login_type') === LOGIN_TYPE_ADMIN || reactLocalStorage.get("is_have_api_basicForgerypdf_service") === SERVICE31_TEXT) {
      const is_data = this.state.is_data_found;
      return (
        <div className="wrapper">
          <Header />
          <div className="container">
            <div className="whiteBox challanPdfPage">
              <div className="titleRow">
                <div className="row">
                  <div className="col">
                    <h3 className="title">Basic Forgery Details</h3>
                  </div>
                  <div className="col">
                    <NavLink
                      to={this.state.urlForBackButton}
                      exact
                      style={{
                        float: 'right',
                        fontSize: '13px',
                        color: '#1a73e8',
                        textDecoration: 'none',
                      }}
                    >
                      {' '}
                      <i className="fa fa-arrow-left" /> Back
                    </NavLink>
                  </div>
                </div>
              </div>
              <div className="mapFilterRow">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="control-title">Identity Card Type  <span className="ex">*</span> {this.state.docType}</label>
                      <select className="form-control" onChange={
                        (e) => {
                          this.setState({docType:e.target.value})
                        }
                      }>
                        <option value="">--select--</option>
                        <option value="aadhaar">Aadhar Card</option>
                        <option value="individualPan">Individual PAN Card</option>
                        <option value="businessPan">Business PAN Card</option>
                        <option value="dl">Driving Licence Card</option>
                        <option value="passport">Passport</option>
                        <option value="voterId">Voter ID Card</option>
                        <option value="unknown">Other</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="control-title">Identity Card <span className="sub">(Upload only jpeg/png/gif/pdf) <span className="ex">*</span></span>  </label>
                      <input className="form-control doc-files" type="file" multiple onChange={e => this.On_docs_input_change(e)} accept="image/jpeg,image/gif,image/png,application/pdf" />
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="pre-doc-img">
                      {
                        (this.state.docFiles.length > 0) ? <div>
                          <div className="form-group">
                            <label className="control-title">Selected Files </label><br />
                            {
                              this.state.docFiles.map((img, i)=> <span className="name" key={i}>{img}</span>)
                            }
                          </div>
                        </div>
                        : ""
                      }
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="control-title">Matched by</label>
                      <Select2 multiple data={this.state.textMachedByDefault} className="form-control defaultOrder" options={{placeholder: 'matched by...', tags: false } } value={this.state.textMachedByField} onChange={this.handleChangeMachedBy.bind(this)} />
                    </div>
                  </div>
                  {
                    (this.state.textMachedByField.length > 0) ? 
                    this.state.textMachedByField.map((item, i)=>
                      <div className="col-md-3 matchField" key={item} data-id={item}>
                        <div className="form-group">
                          <label className="control-title">
                            Matched {this.state.textMachedByDefault.filter((it)=> (it.id == item))[0].text}
                          </label>
                          <input className="form-control" type="text" placeholder="enter value..." />
                        </div>
                      </div>
                    )
                    : ''
                  }
                  <div className="col-md-1">
                    <div className="btnRow">
                      <button
                        className="yellowBtn"
                        type="button"
                        tabIndex="3"
                        onClick={this.get_basic_forgery_details}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                 <div className="col-md-1">
                    <div className="btnRow">
                      <button
                        className="yellowBtn"
                        type="button"
                        style={{ backgroundColor: '#1a73e8' }}
                        tabIndex="4"
                        onClick={this.createAndDownloadPdf}
                      >
                        Download
                      </button>
                    </div>
                  </div> 
                </div>
                <br />
                <div className="challanInfoBlock">
                  {is_data ? (
                      <>
                         <div className="challanBox">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Is Forgery : </div>
                                <div className="val">
                                  {this.state.basic_forgery_details.isForgery}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Forgery Message : </div>
                                <div className="val">{this.state.basic_forgery_details.forgeryMessage}</div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Identity Card Match : </div>
                                <div className="val">
                                  {this.state.basic_forgery_details?.identityCardDetail_match}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Identity Card Type : </div>
                                <div className="val">
                                  {this.state.basic_forgery_details?.identityCardDetail_predictedType}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Color Forgery : </div>
                                <div className="val">
                                  {this.state.basic_forgery_details?.colorDetail_forgery}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="infoRow">
                                <div className="key">Color Message : </div>
                                <div className="val">
                                  {this.state.basic_forgery_details?.colorDetail_message}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="infoRow">
                                <div className="key">Color Colors : </div>
                                <div className="val">
                                  {this.state.basic_forgery_details?.colorDetail_dominantColors}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="infoRow">
                                <div className="key">Text Match Detail : </div>
                                <div className="val">
                                  {JSON.stringify(this.state.basic_forgery_details?.textMatchDetail_textMatchDetail)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                  ) : (
                    <>
                      <div className="infoRow">
                        <div
                          style={{
                            color: '#1a73e8',
                            display: 'inline',
                            fontSize: '30px',
                          }}
                        >
                          {this.state.data_not_found}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="loader" style={{ display: 'none' }}>
            <div className="bg" />
            <img
              className="loadingImg"
              src="/assets/images/loading.gif"
              alt=""
            />
          </div>
        </div>
      );
    } else {
      return <UnAuthorised />;
    }
  }
}
export default basicForgeryPdf;
